export enum SUCCESS_MESSAGES {
  CreateLayerSuccess = "Global Adjustment Layer has been created successfully.",
  DeleteLayerSuccess = "Global Adjustment Layer has been deleted successfully.",
}
